import React, { useEffect, useState } from "react";
import "./staff_referral.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  HR_CONNECT_STAFF_REFERRAL_LIST,
} from "../../../routes";
import { Loader } from "@progress/kendo-react-indicators";
import moment from "moment";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { fetchStaffReferralAudit, fetchStaffReferralDetail, updateStaffReferralStatus } from "../../../store/staff_referral";
import { allStatusConfig } from "./configData";
import { ShowStatusUpdateDialog } from "./statusUpdateDialog";

export const StaffReferralDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const [detailLoading, setDetailLoading] = useState(false);
  const [auditLoading, setAuditLoading] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [auditData, setAuditData] = useState([]);
  const [tempStatus, setTempStatus] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "hr_connect.access_staff_referral"
  );
  const EditPermssion = checkPermission(
    userPermissions,
    "hr_connect.update_status_staff_referral"
  );
  const getData = () => {
    setDetailLoading(true);
    setAuditLoading(true);
    dispatch(fetchStaffReferralAudit(id)).then((res) => {
      console.log(res.payload);

      if (res.payload.status_code === 200) {
        setAuditData(res.payload.data);
        setAuditLoading(false);
      } else {
        setAuditLoading(false);
        alert(res.payload.message);
      }
    });
    dispatch(fetchStaffReferralDetail(id)).then((res) => {
      console.log(res.payload);

      if (res.payload.status_code === 200) {
        // dispatch(fetAud)

        setDetailData(res.payload.data);
        setDetailLoading(false);
        let status = allStatusConfig.filter(status => status.name.toLocaleLowerCase() === res.payload.data.status.toLocaleLowerCase())


        setTempStatus(status[0])
      } else {
        setDetailLoading(false);
        alert(res.payload.message);
      }
    });
  };
  useEffect(() => {
    getData();
  }, [id]);

  const updateStatus = () => {
    setShowStatus(false);
    setDetailLoading(true);
    let params = {
      id: id,
      status: tempStatus.id,
    };
    dispatch(
      updateStaffReferralStatus({ data: params, id: id })
    ).then((res) => {
      if (res.payload.status_code === 200) {
        setTempStatus("");
        getData();
      } else {
        setDetailLoading(false);
        alert(res.payload.message);
      }
    });
  };

  function getStatusById(id) {
    return allStatusConfig.find(status => status.id === id);
  }

  function getStatusList(temp) {
    if (temp.id === "notsuitable" || temp.id === "withdraw") {
      return [];
    }

    if (temp.id === "offered&accepted") {
      return [getStatusById('completed'), getStatusById('withdraw')];
    }

    if (temp.id === "shortlistedforinterview") {
      return [getStatusById('offered&accepted'), getStatusById('withdraw')];
    }

    if (temp.id === "submitted") {
      return [getStatusById('shortlistedforinterview'), getStatusById('notsuitable')];
    }
    return [];
  }


  const RenderRow = ({ title, value }) => {
    return (
      <>
        {value ? (
          <>
            <div className="staff_referral_detail_child_box_main_detail_items">
              <div className="staff_referral_detail_child_box_main_detail_items_title staff_referral_detail_center_item staff_referral_detail_padding_bottom">
                {title}
              </div>
              <div className="staff_referral_detail_child_box_main_detail_items_splitter" />
              <div className="staff_referral_detail_center_item staff_referral_detail_child_box_main_detail_items_subdetail staff_referral_detail_padding_bottom">
                <>
                  <div dangerouslySetInnerHTML={{ __html: value }} />
                </>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      {viewPermssion ? (
        <>

          {showStatus && (
            <ShowStatusUpdateDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={getStatusList(tempStatus)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {detailLoading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <div className="staff_referral_detail_main_box">
              <div className="staff_referral_detail_child_box">
                <div className="staff_referral_detail_left_box">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      className="staff_referral_detail_back"
                      onClick={() => navigate(HR_CONNECT_STAFF_REFERRAL_LIST)}
                    >
                      <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                      Back
                    </div>

                  </div>
                  <div className="staff_referral_detail_child_box_main_detail_box">

                    <RenderRow
                      title={"Name of Referee as per NRIC"}
                      value={detailData && detailData.name
                        ? detailData.name
                        : "-"}
                    />
                    <RenderRow
                      title={"Nationality"}
                      value={detailData && detailData.nationality
                        ? detailData.nationality
                        : "-"}
                    />
                    <RenderRow
                      title={"Singapore Contact Number"}
                      value={detailData && detailData.contact_no
                        ? detailData.contact_no
                        : "-"}
                    />
                    <RenderRow
                      title={"Position Applying"}
                      value={detailData && detailData.position
                        ? detailData.position
                        : "-"}
                    />

                    <RenderRow
                      title={"Own a Class 3 Singapore DL more than 1 year?"}
                      value={detailData && detailData.is_own_dl_more_than_1year
                        ? detailData.is_own_dl_more_than_1year ? 'YES' : 'NO'
                        : "-"}
                    />

                    <RenderRow
                      title={"Applied Date Time"}
                      value={detailData && detailData.created_on
                        ? moment(new Date(detailData.created_on)).format(
                          "DD MMM YYYY, hh:mm a"
                        )
                        : "-"}
                    />
                    <RenderRow
                      title={"Applied By"}
                      value={detailData && detailData.created_by?.name
                        ? detailData.created_by.name
                        : "-"}
                    />

                  </div>
                </div>
                <div className="staff_referral_detail_right_box">
                  <div className="staff_referral_detail_right_status_box">
                    <div className="staff_referral_detail_right_box_status_title">
                      Status
                    </div>
                    <div className="staff_referral_detail_right_box_status_subdetail">
                      {detailData && detailData.status
                        ? detailData.status
                        : "-"}
                    </div>
                  </div>
                  {(detailData.status !== 'Not Suitable' && detailData.status !== 'Completed' && detailData.status !== 'Withdraw') && <div className="staff_referral_detail_right_box_action_main_box">
                    <div className="staff_referral_detail_right_box_action_title">
                      Actions
                    </div>

                    {EditPermssion ? (
                      <div
                        className="staff_referral_detail_right_box_action_edit"
                        onClick={() => setShowStatus(true)}
                      >
                        Update Status &#x2192;
                      </div>
                    ) : (
                      ""
                    )}

                  </div>}
                  <div className="staff_referral_detail_right_box_action_main_box">
                    <div className="staff_referral_detail_right_box_action_title">
                      Activity Trail
                    </div>
                    <div className={auditData.length <= 1 && "audit_bar_hide"}>
                      {auditLoading ? (
                        <Loader
                          type="converging-spinner"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#ffffff4d",
                          }}
                        />
                      ) : (
                        <Stepper
                          orientation={"vertical"}
                          items={auditData}
                          item={CustomStep}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
